query getSavedDesignSources($id: ID!) {
	savedDesignById(id: $id) {
		backgroundMaskImageUrl
		colorisationImageUrl
		enhanceFacesImageUrl
		faceBoundingBoxes {
			x
			y
			width
			height
		}
	}
}